import { Button, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useSessionContext } from "../../contexts/SessionContext";
import { useState } from "react";
import { Notify } from "../../services/Notify";
import ArchiveConsultation from "../../services/Archive/ArchiveConsultation";
import archiveService from "../../services/Archive/ArchiveService";
import React from "react";
import { useNavigate } from "react-router-dom";
import FormatHelpers from "../../services/FormatHelper";

export default function ArchivesPage() {
  const navigate = useNavigate();
  const { organization } = useSessionContext();
  const [consults, setConsults] = useState<ArchiveConsultation[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [text, setText] = useState<string>("");
  const [total, setTotal] = useState<number>(0);

  const maxResults = 500;

  async function getConsults() {
    if (organization && text.length > 0) {
      try {
        setLoading(true);
        const list = await archiveService.getConsults(organization.organization.id, text);
        if (list.length > maxResults) {
          setConsults(list.splice(0, maxResults));
        } else {
          setConsults(list);
        }
        setTotal(list.length);
        setLoading(false);
      } catch (e) {
        Notify.error("Erreur chargement");
      }
    } else {
      setConsults([]);
      setLoading(false);
    }
  }

  return (
    <Container sx={{ marginTop: 5 }}>
      <Stack direction="row" alignItems={"center"} spacing={1} mb={3}>
        <Typography>Recherche</Typography>
        <TextField size="small" value={text} onChange={(ev: any) => setText(ev.target.value)} sx={{ flex: 1 }} />
        <Button variant="contained" onClick={() => getConsults()}>
          Rechercher
        </Button>
      </Stack>

      {consults.length > 0 && (
        <Stack direction="row" gap={1}>
          <Typography mt={2} fontWeight={700}>
            <span>{total}</span> consultation{consults.length > 1 ? "s" : ""} trouvée{consults.length > 1 ? "s" : ""}.
          </Typography>

          {total > consults.length && (
            <Typography mt={2} fontWeight={700} color={"warning.main"}>
              Seulement les <span>{consults.length}</span> premières consultations sont affichées.
            </Typography>
          )}
        </Stack>
      )}

      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table>
          <TableHead>
            <TableCell>id</TableCell>
            <TableCell>createdAt</TableCell>
            <TableCell>firstName</TableCell>
            <TableCell>lastName</TableCell>
            <TableCell>email</TableCell>
            <TableCell>phone</TableCell>
            <TableCell>shortId</TableCell>
            <TableCell>status</TableCell>
            <TableCell>type</TableCell>
          </TableHead>
          {!loading && (
            <TableBody>
              {consults.map((c) => {
                return (
                  <React.Fragment key={c.id}>
                    <TableRow onClick={() => navigate(`/organizations/${organization?.organization.id}/admin/archives/${c.id}`)}>
                      <TableCell>{c.id}</TableCell>
                      <TableCell>{FormatHelpers.formatDateTimeShort(c.createdAt)}</TableCell>
                      <TableCell>{c.firstName}</TableCell>
                      <TableCell>{c.lastName}</TableCell>
                      <TableCell>{c.email}</TableCell>
                      <TableCell>{c.phone}</TableCell>
                      <TableCell>{c.shortId}</TableCell>
                      <TableCell>{c.status}</TableCell>
                      <TableCell>{c.type}</TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {loading && (
        <Typography mt={2} textAlign="center">
          Recherche en cours...
        </Typography>
      )}

      {text.length === 0 && (
        <Typography mt={2} textAlign="center">
          Veuillez entrer un mot-clé de recherche pour obtenir une liste des consultations contenant ce texte.
        </Typography>
      )}
    </Container>
  );
}
